import { Call, ApiUrl, ParseGeneralResponse } from "./ApiUtils";

export const FsuUpdateStatusApi = {
  // pickupCompletions: [{ customer_order_id, pickup_driver_id, pickup_completed_at }] - only for
  // orders PickupLegCandidatesApi.fetchCandidates said still need it.
  bulkStatusUpdate: (organizationId, currentWarehouseId, warehouseId, status, datetime, customerOrderIds, pickupCompletions = [], manifestNumber = null) => {
    const url = ApiUrl("v2/customer_orders/bulk_status_update");
    const data = {
      organization_id: organizationId,
      current_warehouse_id: currentWarehouseId,
      warehouse_id: warehouseId,
      status,
      datetime,
      customer_order_ids: customerOrderIds,
      pickup_completions: pickupCompletions,
      manifest_number: manifestNumber,
    };
    return Call("put", url, data, ParseGeneralResponse, {
      responseDataKeys: {
        results: "results",
        summary: "summary",
      },
    });
  },

  // Of the given orders, returns only the ones whose pickup leg still needs manual completion -
  // excludes orders already COMPLETED or already past their origin warehouse per Linehaul
  // tracking. For status RECEIVED, also excludes orders whose warehouseId is their own origin.
  fetchPickupLegCandidates: (organizationId, customerOrderIds, status = "ON_HAND", warehouseId = null) => {
    const url = ApiUrl("v2/customer_orders/pickup_leg_candidates");
    const data = {
      organization_id: organizationId,
      customer_order_ids: customerOrderIds,
      status,
      warehouse_id: warehouseId,
    };
    return Call("put", url, data, ParseGeneralResponse, {
      responseDataKeys: {
        candidates: "candidates",
      },
    });
  },
};
